import React from "react";
import { makeStyles } from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";
import { RootNavTabs } from "../../data/RootNavTabs";
import { routes } from "../../routing/routes";
import PickaaGO1Icon from "../../assets/Images/PickaaGoLogo.png";


const customStyles = makeStyles({
  root: {
    maxWidth: "100vw",
    width: "100%",
    position: "sticky",
    top: "0",
    transition: "all .4s ease",
    willChange: "unset",
    backgroundClip: "padding-box",
    position: "relative",
    zIndex: 2,
    fontFamily: "Manrope",
  },
  navWrapper: {
    padding: "0 70px",
    display: "flex",
  },
  iconWrapper: {
    margin: "28px 0px",
    height: "28px",
    position: "relative",
  },
  PickaaGO1Icon: {
    height: "70px",
    transition: "all .2s ease",
    marginLeft: "-50px",
    marginTop: "-30px"

  },
  navBar: {
    marginLeft: "-50px",
    display: "flex",
    flex: "1",
    justifyContent: "space-between",
    marginLeft: "70px",
  },
  navLinks: {
    display: "flex",
    flex: "1",
    justifyContent: "flex-start",
  },
  tabUL: {
    display: "flex",
    listStyle: "none",
    margin: "0",
    padding: "0",
    boxSizing: "border-box",
    gap: "42px",
    fontFamily: ""

  },
  tabLI: {
    alignItems: "center",
    display: "flex",
    listStyle: "none",
    margin: "0",
    padding: "0",
    fontFamily: "Roboto"

  },
  tabA: {
    transition: "all .2s ease",
    display: "block",
    cursor: "pointer",
    textDecoration: "none",
    color: "rgb(39, 19, 64)",
    fontWeight: "600",
    fontFamily: "Roboto"
  },
  navBtn: {
    alignItems: "center",
    display: "flex",
    fontFamily: "Roboto"

  },
  // Targeting very small mobile devices or feature phones (e.g., early Nokia phones, very small Android phones)
  '@media (max-width: 319px)': {
    navWrapper: {
      padding: "0 5px",
      flexDirection: "column",
    },
    tabUL: {
      display: "flex",
      gap: "8px",
      flexWrap: "wrap",
    },
    tabA: {
      fontSize: "10px",
    },
    navBtn: {
      fontSize: "10px",
      marginLeft: "-50px",
    },
    PickaaGO1Icon: {
      height: "40px",
    },
  },

  // Targeting small smartphones or older mobile devices (e.g., iPhone 5/5S, Samsung Galaxy S4, HTC One)
  '@media (min-width: 320px) and (max-width: 480px)': {
    navWrapper: {
      padding: "0 10px",
      flexDirection: "column",
    },
    tabUL: {
      gap: "15px",
      marginLeft: "-140px",
      zIndex: 0,

    },
    tabA: {
      fontSize: "12px",
    },
    navBtn: {
      fontSize: "10px",
      marginTop: "-95px",
      marginLeft: "-200px",
    },
    signupBtn: {
      position: "relative",
      zIndex: 1,
    },
    PickaaGO1Icon: {
      height: "65px",
      marginTop: "-10px"
    },
  },

  // Targeting mid-sized smartphones and small tablets (e.g., iPhone 6/7/8, iPad Mini, Nexus 7, Samsung Galaxy Tab)
  '@media (min-width: 481px) and (max-width: 768px)': {
    navWrapper: {
      padding: "0 15px",
      flexDirection: "column",
    },
    tabUL: {
      gap: "16px",
    },
    tabA: {
      fontSize: "6px",
      marginLeft: "-20px"
    },
    navBtn: {
      fontSize: "4px",

    },
    PickaaGO1Icon: {
      height: "60px",
    },
  },

  // Targeting tablets in landscape mode, small laptops, and some large tablets (e.g., iPad Pro, MacBook Air 11", Samsung Galaxy Tab S4)
  '@media (min-width: 769px) and (max-width: 1024px)': {
    navWrapper: {
      padding: "0 20px",
      flexDirection: "row",
    },
    tabUL: {
      gap: "20px",
    },
    tabA: {
      fontSize: "16px",
    },
    navBtn: {
      fontSize: "16px",
    },
    PickaaGO1Icon: {
      height: "70px",
    },
  },
});

const RootTopBar = () => {
  const navigate = useNavigate();
  const classes = customStyles();

  return (
    <div className={classes.root}>
      <div className={classes.navWrapper}>
        <div className={classes.iconWrapper}>
          <img
            className={classes.PickaaGO1Icon}
            src={PickaaGO1Icon}
            alt="Description of the image"
          />
        </div>
        <div className={classes.navBar}>
          <div className={classes.navLinks}>
            <ul className={classes.tabUL}>
              {RootNavTabs.map((tab) => {
                console.log(`Nav Tab [${tab.label}]:`, tab.tabUrl);
                return (
                  <li key={tab.id} className={classes.tabLI}>
                    <Link to={tab.tabUrl || "#"} className={classes.tabA}>
                      <span>{tab.label}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className={classes.navBtn}>
            <div
              style={{ fontFamily: "Roboto" }}

              className={"purpleBtn"}
              onClick={() => {
                navigate(routes.PUSER_LOGIN);
              }}
            >
              Log In
            </div>
            <div
              style={{ marginLeft: "20px", fontFamily: "Roboto" }}
              className={"purpleBtn"}
              onClick={() => {
                navigate(routes.PSIGN_UP);
              }}
            >
              Sign Up
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default RootTopBar;
